import "./index.css";
import React from "react";
import pdfIcon from "../../../../assets/media/pdf.png";
import { getYoutubeId } from "../../../../Utils/utils";
import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
  PDF_UPLOAD,
} from "../../../../Constants/types";

export default function UploadItem({ media, onDelete, onPdfClick }) {
  const isPDF = media && media.mediaType === PDF_UPLOAD;

  const renderPlaceholder = () => <div className="upload-panel__placeholder" />;

  const renderImageOrGif = () => {
    const { mediaUrl, mediaType } = media;
    return (
      <img
        src={mediaUrl}
        alt={`uploaded ${mediaType === GIF_UPLOAD ? "gif" : "image"}`}
        className="upload-panel__image"
      />
    );
  };

  const renderVideo = () => {
    return (
      <video controls={true} className="upload-panel__video">
        <source src={media.mediaUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    );
  };

  const renderYoutube = () => (
    <iframe
      title="video"
      width="100%"
      height="100%"
      src={`//www.youtube.com/embed/${getYoutubeId(
        media.mediaUrl
      )}?modestbranding=1&showinfo=0`}
      allowFullScreen
      className="upload-panel__iframe"
    />
  );

  const renderPDF = () => (
    <img src={pdfIcon} alt="uploaded pdf" className="upload-panel__pdf" />
  );

  const renderContent = () => {
    if (!media || !media.mediaUrl) {
      return renderPlaceholder();
    }

    switch (media.mediaType) {
      case GIF_UPLOAD:
      case IMAGE_UPLOAD:
        return renderImageOrGif();
      case VIDEO_UPLOAD:
        return renderVideo();
      case YOUTUBE_URL:
        return renderYoutube();
      case PDF_UPLOAD:
        return renderPDF();
      default:
        return renderPlaceholder();
    }
  };

  const onDeleteMedia = (e, media) => {
    e.stopPropagation();
    onDelete(media);
  };

  return (
    <div
      className={`upload-panel__container ${
        isPDF ? "upload-panel--hoverable" : ""
      }`}
      onClick={isPDF ? () => onPdfClick(media.mediaUrl) : null}
    >
      {media && onDelete && (
        <button
          className="upload-panel__delete-button"
          title="Delete content"
          onClick={(e) => onDeleteMedia(e, media)}
        >
          &times;
        </button>
      )}
      {renderContent()}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/UploadPanel/components/UploadItem/index.js